import React from 'react'
import { Nav as ReactstrapNav, NavProps } from 'reactstrap'

export const Nav: React.FC<NavProps> = props => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <ReactstrapNav {...(props as any)} />
}
